import {
  Modal,
  ModalBody,
  ModalFooterDefault,
  ModalHeaderDefault,
} from 'ui-components/dist/Modal';

export interface ISavedListShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
}

export const ExportConfirmationModal: React.FC<ISavedListShareModalProps> = ({
  isOpen,
  onClose,
  email,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeaderDefault title="Check your inbox" />
      <ModalBody>
        Your exported list is on its way to {email}. It may take a few minutes
        to arrive.
      </ModalBody>
      <ModalFooterDefault
        primary={{
          ariaLabel: 'Got it',
          title: 'Got it',
          variant: 'primary',
          onClick: onClose,
        }}
      />
    </Modal>
  );
};
